import RecentMedicaidId from './RecentMedicaidId';

export default RecentMedicaidId;
